import React from 'react';
import { getConfigValue } from '@indigo-ag/ui-core';
import i18next from 'i18next';

export const environmentIndicator = getConfigValue('IA_ENV');

export const EnvironmentBar: React.FunctionComponent = () => {
  if (environmentIndicator === 'staging') {
    return (
      <div
        style={{
          backgroundColor: '#899ca5',
          color: '#303c41',
          height: 30,
          fontSize: 14,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          position: 'fixed',
          zIndex: 100,
          margin: 0,
          padding: 0
        }}
      >
        {i18next.t('testingEnvironment')}
      </div>
    );
  }
  return null;
};
